// --- (1), (2) & (3): install and import ---
import React from "react";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import 'leaflet/dist/leaflet.css';
import "../../App.css"; 
import borders from "./borders.json";
import UtilsLocalizedString from "../../services/utilsLocalizedString";



function SpeciesMap(props) {
  const setColor = ({ properties }) => {
    return { weight: 0.7, color: "darkGreen" };
  };

  function GeoJSONComponent({ data }) {

    const onEachFeature = (feature, layer) => {

      if (feature.properties && feature.properties.romnam) {
        console.log("this is one feature");
        console.log(feature.properties);
        console.log(props.data[0]);
       // const tooltipContent = props.data.toString();
         const tooltipContent = UtilsLocalizedString(props.lang, props.data.filter((obj) => obj.territory.iso3 === feature.properties.iso3cd)[0].territory);
  
        layer.on("mouseover", function (e) {
          this.bindTooltip(`${tooltipContent}`, {sticky: "true"})
        });
      }
    };
  
    return (
      <GeoJSON
        data={data}
        onEachFeature={onEachFeature}
        style={setColor}
      />
    );
  }
  
var countryArray = props.data.length > 0 ? props.data.map(record => record.territory.iso3) : [];
  return (
    <section className='map-component' >
      <div className='map'>
      <MapContainer center={[20,0]} zoom={2}  scrollWheelZoom={true} style={{ width: "100%", height: "50vh", zIndex: 0}} className="ratio ratio-21x9">
      
        <TileLayer
         attributionPrefix="Leaflet"
          attribution='© UN'
          maxZoom={18}
          minZoom={1}
          url="https://pro-ags1.dfs.un.org/arcgis/rest/services/basemaps/clearmap_webtopo_nolabel_cvw/MapServer/tile/{z}/{y}/{x}"
        
         // url="https://pro-ags1.dfs.un.org/arcgis/rest/services/basemaps/clearmap_webtopo_nolabel_cvw/MapServer/tile/{z}/{y}/{x}"
          //"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          // --- (7) Alternative map style (attribution and url copied from the leaflet extras website) ---
          // attribution='&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
          // url='https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png'
          // --- -------------------------------------------------------------------------------------- ---
        />

          {countryArray.length > 0 && borders.features.filter((polygon) => countryArray.includes(polygon.properties.iso3cd)).map((feature, index) => (
          <GeoJSONComponent key={index} data={feature} />
        ))}
      </MapContainer>
      </div>
    </section>
  )
}
export default SpeciesMap